import { useMemo } from "react";
import {
  InternalAdminDistributionGroupQuery,
  InternalAdminDistributionGroupQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_DISTRIBUTION_GROUP_QUERY from "../_networking/internal-admin-distribution-group";

const useInternalAdminDistributionGroups = (
  id: string | string[] | undefined,
) => {
  const isValid = (Array.isArray(id) && id.length > 0) || !!id;

  const { data, loading } = useQuery<
    InternalAdminDistributionGroupQuery,
    InternalAdminDistributionGroupQueryVariables
  >(INTERNAL_ADMIN_DISTRIBUTION_GROUP_QUERY, {
    fetchPolicy: "network-only",
    variables: id
      ? {
          id,
        }
      : undefined,
    skip: !isValid,
  });

  const distributionGroups = useMemo(() => {
    if (!data) return [];
    return data.internalAdminDistributionGroup;
  }, [data]);

  const distributionGroup = useMemo(() => {
    if (distributionGroups && distributionGroups.length === 1) {
      return distributionGroups[0];
    }
    return undefined;
  }, [distributionGroups]);

  return {
    distributionGroup,
    distributionGroups,
    loading,
  };
};

export default useInternalAdminDistributionGroups;
